import { computed, Injectable, signal } from '@angular/core';

/**
 * Handle visibility of application wide progress bar.
 */
@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  /**
   * Number of running tasks (how often start() was triggered).
   */
  private noOfRunningTasksSignal = signal(0);

  constructor() {}

  /**
   * True if progress bar is to be shown.
   *
   * False if all running tasks were completed.
   */
  get showProgressBar() {
    return computed(() => this.noOfRunningTasksSignal() > 0);
  }

  /**
   * Add an event to the progress bar queue.
   */
  start() {
    this.noOfRunningTasksSignal.update((tasks) => tasks + 1);
  }

  /**
   * Remove an event to the progress bar queue.
   *
   * Hint: remember to also call this on error.
   */
  stop() {
    this.noOfRunningTasksSignal.update((tasks) => tasks - 1);
  }
}
